export default __webpack_public_path__ + "static/media/Professora.a8ef4278.png";